import React, {useCallback, useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux"
import {generatePath} from "react-router"
import {Link, Redirect, useHistory} from "react-router-dom"

import {loadStripe} from '@stripe/stripe-js';

import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';

import axios from "axios"
import moment from "moment"
import {toast} from "react-toastify"


import {TextField, Button} from "@material-ui/core"

import {ThemeProvider} from '@mui/material/styles'
import IconGift from '@material-ui/icons/CardGiftcard'
import IconGo from '@material-ui/icons/DoubleArrow'
import IconRestart from '@material-ui/icons/Replay'
import {makeStyles} from "@material-ui/styles"
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import FormControlLabel from '@mui/material/FormControlLabel'

import DoubleSwitch from '../common/DoubleSwitch'

import IconHelp from '@material-ui/icons/Help'

import {urlApi} from "../../api"
import {loadingToggle} from "../../store/actions/appActions"
import theme from '../../themes/_main'
import {useStyles} from '../../themes/styles'

import isEmail from '../../fns/isEmail'
import {sortTimes} from '../../fns/times'

const stripePromise = loadStripe("pk_test_51RDyTyDUWAYG8wIto0ad0qMnrifPuI75HO8wBqBYG3YPerYwx40CAwW5dg4NthoPBUvSDNciWdTDHs19jOb9Ktq9003cSQxLIc");


const humanReadableFromTier = (tier) => {
  if (tier === undefined) {
    return "ANALYSIS"
  }
  const type = (tier?.fullAnalysis ? "Full Deck" : "Next Card")
  return (type + " Analysis")
}

const fontSizes = {
  h1: 24,
  h2: 22,
  h3: 20,
  b1: 18,
  b2: 16,
}

const fieldsArr = [
  "ossEmailGift",
  "ossGiftMessage",
  "ossSongInfo",
  "ossSongStyle",
]

let fields = {}
for (let i = 0; i < fieldsArr.length; ++i) {
  fields[fieldsArr[i]] = ""
}

// const fields = {
//   ossEmailGift: "",
//   ossSongInfo: "",
//   ossSongStyle: "",
// }

const pageStyles = makeStyles({
  divider: {
    height: "50px",
  },
  formStyle: {
    margin: "0px auto",
    padding: "30px",
    borderRadius: "9px",
    boxShadow: "0px 0px 12px -3px #000",
  },
  spacing: {
    marginTop: "20px",
  },
})

// sx={{ '& .MuiFormControlLabel-label': { fontSize: fontSizes.h1, "paddingTop": "7px", "&.Mui-disabled":{color: "black"} } }}
// sx={{fontSize: fontSizes.h1, fontWeight: 'bold', "paddingTop": "7px", color: (getChecked(step) ? "black" : "grey")}}

// sx={{ '& .MuiFormControlLabel-label': {, "&.Mui-disabled":{color: "black"} } }}
// sx={{color: (getChecked(step) ? "black" : "grey")}}
const sxList = {
  fontSize: fontSizes.h1,
  paddingTop: "7px",
}
const sxListBold = {
  ...sxList,
  fontWeight: 'bold',
}

const Purchase = function DotsMobileStepper(props) {
  const dispatch = useDispatch()
  const history = useHistory()
  // const app = useSelector()
  const inputLimits = useSelector(state => state.app).dataServer.inputLimits
  const prices = useSelector(state => state.app.dataServer.prices)
  const classes = useStyles()

  const [analysisType, setAnalysisType] = React.useState("")
  const [openGift, setOpenGift] = React.useState("")
  const [openNoSurvey, setOpenNoSurvey] = React.useState(false)
  const [openReset, setOpenReset] = React.useState("")
  const [openSpend, setOpenSpend] = React.useState("")
  const [openStripe, setOpenStripe] = React.useState(false)
  const [openSurvey, setOpenSurvey] = React.useState(false)
  const state = {
    checkingOut: false,
    fullAnalysis: true,
    redirection: {},
    tierLevel: 0,
  }
  const [giftChecked, setGiftChecked] = React.useState(false)
  const [purchases, setPurchases] = React.useState([])
  const [surveyAvailable, setSurveyAvailable] = React.useState(false)
  const [fullCount, setFullCount] = React.useState(0)
  const [nextCount, setNextCount] = React.useState(0)
  const [stripeReady, setStripeReady] = React.useState(false)
  const [surveyUrl, setSurveyUrl] = React.useState("")
  const [total, setTotal] = React.useState(prices[0].price)
  const [errorEmailGift, setErrorEmailGift] = React.useState("")
  const [errorSongInfo, setErrorSongInfo] = React.useState("")
  const [errorSongStyle, setErrorSongStyle] = React.useState("")
  const [emailGift, setEmailGift] = React.useState("")
  const [songInfo, setSongInfo] = React.useState("")
  const [songStyle, setSongStyle] = React.useState("")
  const [date, setDate] = React.useState("")
  const [time, setTime] = React.useState(0)
  const [times, setTimes] = React.useState({})
  const [dates, setDates] = React.useState([])
  const [inputs, setInputs] = React.useState(fields)
  const [errors, setErrors] = React.useState(fields)
  const [disableSubmit, setDisableSubmit] = React.useState(true)
  const [showCheckout, setShowCheckout] = React.useState(false)
  const strAnalysis = ""

  let priceObj = {}
  for (let i = 0; i < prices.length; ++i) {
    // console.log(priceKeys[i])
    priceObj[prices[i].item] = false
  }

  const [pricesObjChecked, setPricesObjChecked] = React.useState(priceObj)

  const [pricesChecked, setPricesChecked] = React.useState(new Array(prices.length).fill(false))

  const disabledButton_modify = (purchase) => {
    return (!purchase.isStarted && purchase.isGift)
  }

  const blurField = (field) => {
    console.log("BLUR")
    let blurErrors = {...errors}
    switch (field) {
      case "ossEmailGift":
        console.log("OEG")
        blurErrors.ossEmailGift = isEmail(inputs.ossEmailGift) ? "" : "Please enter a valid email address"
        break
      case "ossSongInfo":
        blurErrors.ossSongInfo = inputs.ossSongInfo.length ? "" : "Please let us know what you would like your song to be about"
        break
      case "ossSongStyle":
        blurErrors.ossSongStyle = inputs.ossSongStyle.length ? "" : "Please let us know what style you would like your song to be"
        break
      default:
    }
    setErrors(blurErrors)
    checkDisableSubmit(giftChecked, inputs, blurErrors, time)
  }

  const changeEmail = (event) => {
    var val = event.target.value
    // const max = inputLimits[typeLimit].max
    // if (val.length > max) {
    //   val = val.slice(0, max)
    // }
    // inputs[typeUser] = val
    // setInputs({...inputs})
    setEmailGift(val)
    console.log(pricesObjChecked)
  }

  const changeText = (event, setVal) => {
    var val = event.target.value
    setVal(val)
  }

  const changeVal = (event, field) => {
    let changeInputs = {...inputs}
    var val = event.target.value
    const max = inputLimits[field].max
    if (val.length > max) {
      val = val.slice(0, max)
    }
    changeInputs[field] = val
    setInputs(changeInputs)
    checkDisableSubmit(giftChecked, changeInputs, errors, time)
  }

  const checkDisableSubmit = (newGift, newInputs, newErrors, newTime) => {
    if (newGift) {
      if (!newInputs.ossEmailGift || newErrors.ossEmailGift || !isEmail(newInputs.ossEmailGift)) {
        setDisableSubmit(true)
      }
      else {
        setDisableSubmit(false)
      }
    }
    else {
      if (false
        || !newInputs.ossSongInfo
        || newErrors.ossSongInfo
        || !newInputs.ossSongStyle
        || newErrors.ossSongStyle
        || !newTime
      ) {
        setDisableSubmit(true)
      }
      else {
        setDisableSubmit(false)
      }
    }
  }

  const checkEmail = () => {
    if (isEmail(emailGift)) {
      setErrorEmailGift("")
    }
    else {
      setErrorEmailGift("Please enter a valid email address")
    }
  }

  const fetchClientSecret = useCallback(async() => {
    const recaptchaToken = await new Promise((resolve, reject) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute('6LcXmlErAAAAAL3x9T9LPbNHUoQHMT5lmEPjc0vN', { action: 'submit' })
        .then(resolve)
        .catch(reject);
      });
    });
    
    const checkout = {
      pricesObjChecked,
      giftChecked,
      inputs,
      time,
      timezoneOffset: new Date().getTimezoneOffset(),
    }
    const body = {
      recaptchaToken,
      checkout,
      idxPurchase: "",
    }
    const res = await fetch(`${urlApi}/oss/stripe-create-checkout-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const errorText = await res.text(); // fallback if not valid JSON
      throw new Error(errorText || "Failed to create checkout session");
    }

    const data = await res.json();

    if (!data.clientSecret) {
      throw new Error(data.error || "Missing clientSecret in response");
    }

    return data.clientSecret;
  }, [
    pricesObjChecked,
    giftChecked,
    inputs,
    time
  ]);
  const options = {fetchClientSecret};

  const handleModify = async (purchase) => {
    if (purchase.isStarted) {
      await setOpenReset(purchase._id)
    }
  }

  const handleNewAnalysis = async (newAnalysisType) => {
    await setAnalysisType(newAnalysisType)
    setOpenSpend(true)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    dispatch(loadingToggle(true))
    // dispatch(loadingToggle(false))
    console.log("SUBMIT")
    console.log(pricesObjChecked)
    setShowCheckout(true)
    dispatch(loadingToggle(false))

    const body = {
      giftChecked,
      inputs,
      time,
    }
    
    // axios
    // .post(`${urlApi}/oss/create-checkout-session`, body, {"withCredentials": false})
    // // .post(`${urlApi}/oss/getTimes`, {qwe: "asd"}, {"withCredentials": false})
    // .then(resp => {
    //   console.log("resp")
    //   console.log(resp.data)

    //   dispatch(loadingToggle(false))
    //   setShowCheckout(true)
    // })
    // .catch(error => {
    //   toast.error(error.response?.data, {
    //     position: toast.POSITION.BOTTOM_RIGHT,
    //     autoClose: 5000,
    //   })
    //   dispatch({
    //     type: "LOADING_TOGGLE",
    //     isLoading: false,
    //   })
    // })
  }


  const getChecked = (step) => {
  // return false
    if (step.item == "Base Package") return true
    return pricesObjChecked[step.item]
    return false
    console.log(step)
    console.log(pricesObjChecked)
    console.log(pricesObjChecked[step.item])
    return pricesObjChecked[step.item]
    // console.log(pricesChecked[index])
    // return (index == 0 || pricesChecked[index])
  }

  const getCheckedColor = (index) => {
    // return "red"
  
    return getChecked(index) ? "" : "grey"
    const retVal = (index==1 || index==3)
    console.log(index)
    console.log(retVal)
    return (retVal)
    return (index == 0 || pricesChecked(index))
  }

  const getTotal = () => {
    let total = prices[0].price
    for (let i = 1; i < prices.length; ++i) {
      if (getChecked(i)) {
        total += prices[i].price
      }
    }
    return 111
  }

  const handleChangeDate = (event) => {
    setDate(event.target.value)
    setTime(0)
    setDisableSubmit(true)
  }
  const handleChangeTime = (event) => {
    console.log(event.target.value)
    // console.log(times[date][event.target.value])
    // setTime(times[date][event.target.value])
    setTime(event.target.value)
    checkDisableSubmit(giftChecked, inputs, errors, event.target.value)
  }

  // const handleCheck = (index) => {
  //   setGiftChecked(!giftChecked)
  //   console.log(index)
  //   // console.log(checked)
  //   let checks = pricesChecked
  //   checks[index] = !checks[index]
  //   setPricesChecked(checks)
  //   console.log(checks)
  // }

  const handleCheck = (step) => {
    const keys = prices.keys()
    console.log(keys)
    console.log(step)
    console.log(pricesObjChecked)
    let obj = pricesObjChecked
    obj[step.item] = !obj[step.item]
    setPricesObjChecked({...obj})
    setTotal(total + ((obj[step.item] ? 1 : -1) * step.price))
    // setPricesObjChecked({...pricesObjChecked, qwe: false})
  }

  const handleGift = () => {
    const newGiftChecked = !giftChecked
    setGiftChecked(newGiftChecked)
    console.log(giftChecked)
    checkDisableSubmit(newGiftChecked, inputs, errors, time)
  }

  const hideCheckout = () => {
    console.log(pricesObjChecked)
    setShowCheckout(false)
  }


  const script_stripe = document.createElement('script')
  script_stripe.setAttribute("id", "script_stripe")
  script_stripe.src = "https://js.stripe.com/v3/pricing-table.js"
  script_stripe.async = true
  script_stripe.onload = () => {
    setStripeReady(true)
  }
  document.body.appendChild(script_stripe)


  useEffect(() => {

    console.log("PRICES")
    console.log(prices)


    props.socket.on('pollfishCallbackComplete', (id) => {
      history.push(`/analysis/${id}`)
    })

    dispatch(loadingToggle(true))
    console.log("GETTIMES")
    window.grecaptcha.ready(function() {
      window.grecaptcha.execute('6LcXmlErAAAAAL3x9T9LPbNHUoQHMT5lmEPjc0vN', {action: 'submit'}).then(function(recaptchaToken) {
        axios
        .post(`${urlApi}/oss/getTimes`, {recaptchaToken}, {"withCredentials": false})
        .then(respTimes => {
          console.log("respTimes")
          console.log(respTimes.data)
          const sortedTimes = sortTimes(respTimes.data)
          setTimes(sortedTimes)
          const sortedDates = Object.keys(sortedTimes)
          setDates(sortedDates)
          dispatch(loadingToggle(false))
        })
        .catch(error => {
          toast.error(error.response?.data, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          })
          dispatch({
            type: "LOADING_TOGGLE",
            isLoading: false,
          })
        })
      })
    })
    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  if (state["redirection"]._id) {
    return <Redirect to={{
      pathname: generatePath("/analysis/:idAnalysis", {idAnalysis: state["redirection"]._id}),
      location: state["redirection"],
    }}/>
  }
  else if (state["checkingOut"]) {
    return (
      <>
      </>
    )
  }
  else {
    return (
      <Box>
        <ThemeProvider theme={theme}>
          
          <Typography variant="h4">
            Purchase Your Song
          </Typography>
          {showCheckout ? <>
            <div className={classes.spacing}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={hideCheckout}
              >
                Back
              </Button>
            </div>
            <div id="checkout" className={classes.spacing}>
              <EmbeddedCheckoutProvider
                stripe={stripePromise}
                options={options}
              >
                <EmbeddedCheckout />
              </EmbeddedCheckoutProvider>
            </div>
          </> :
            <form
            className={classes.formStyle}
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}>
              <div id="prices">
                {prices.map((step, index) => (
                  <Box
                  key={index}
                  component="span"
                  className={classes.spreadBoxFull + " " + classes.spacing}
                  >
                    {/* <span> */}
                    {/* <FormControlLabel control={<Checkbox />} disabled={index==0} label={step.item} sx={{ '& .MuiFormControlLabel-label': { fontSize: fontSizes.h1, "paddingTop": "7px", color: "red" } }}/> */}
                    {/* <FormControlLabel control={<Checkbox />} disabled={index==0} label={step.item} sx={{ '& .MuiFormControlLabel-label.Mui-disabled': { fontSize: fontSizes.h1, "paddingTop": "7px", color: "red" } }}/> */}
                    <FormControlLabel onChange={() => handleCheck(step)} control={<Checkbox defaultChecked={index==0 || pricesObjChecked[step.item]}/>} disabled={index==0} label={step.item} sx={{ '& .MuiFormControlLabel-label': {...sxList, "&.Mui-disabled":{color: "black"} } }}/>
                    {/* <Typography variant="body1" sx={{fontSize: fontSizes.b1}}>{step.item}</Typography> */}
                    {/* </span> */}
                    <Typography variant="body1" className={/*getChecked(index) ? classes.textGrey : */""} sx={{...sxListBold, color: (getChecked(step) ? "black" : "grey")}}>
                      ${step.price}
                    </Typography>
                    
                  </Box>
                ))}
                <Box
                component="span"
                className={classes.spreadBoxFull + " " + classes.spacing}
                >
                  <div></div>
                  <Typography variant="body1" className={/*getChecked(index) ? classes.textGrey : */""} sx={sxListBold}>
                      -----
                    </Typography>
                </Box>
                <Box
                component="span"
                className={classes.spreadBoxFull + " " + classes.spacing}
                >
                  <Typography variant="body1" className={/*getChecked(index) ? classes.textGrey : */""} sx={{fontSize: fontSizes.h1, fontWeight: 'bold', "paddingTop": "7px"}}>
                      Total
                    </Typography>
                  <Typography variant="body1" className={/*getChecked(index) ? classes.textGrey : */""} sx={{fontSize: fontSizes.h1, fontWeight: 'bold', "paddingTop": "7px"}}>
                      ${total}
                    </Typography>
                </Box>
              </div>

              <FormControlLabel className={classes.spacing} onChange={handleGift} control={<Checkbox/>} label={"This is a gift"} sx={{ '& .MuiFormControlLabel-label': sxList }}/>


              <Typography variant="h6" className={classes.spacing}>
                {giftChecked ?
                  <>
                    <Box className={classes.spacing}>
                      Gift Recipient's Email
                      <TextField
                        id="enter-email"
                        className={classes.spacing}
                        label="Email"
                        variant="outlined"
                        fullWidth
                        value = {inputs.ossEmailGift}
                        onChange = {(event) => changeVal(event, "ossEmailGift")}
                        onBlur = {() => blurField("ossEmailGift")}
                        error = {Boolean(errors.ossEmailGift)}
                        helperText={errors.ossEmailGift}
                      />
                    </Box>
                    <Box className={classes.spacing}>
                      Include a message with your gift:
                      <Tooltip
                      // followCursor={false}
                      title={"You can leave this blank, or add a message for the gft recipient."}
                      >
                        <IconHelp className={classes.spacing + " " + classes.spacingLeft}/>
                      </Tooltip>
                      <TextField
                      id="enter-gift-message"
                      className={classes.spacing}
                      label="Message"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={4}
                      value = {inputs.ossGiftMessage}
                      onChange = {(event) => changeVal(event, "ossGiftMessage")}
                      // onBlur = {() => blurField("ossSongInfo")}
                      // error = {Boolean(errors.ossSongInfo)}
                      // helperText={errors.ossSongInfo}
                      />
                      <Typography variant="body1">{inputs.ossGiftMessage.length} / {inputLimits.ossGiftMessage.max}</Typography>
                    </Box>
                  </>
                :
                  <>
                    <Box className={classes.spacing}>
                      What would you like your song to be about?
                      <Tooltip
                      // followCursor={false}
                      title={"Tell us about your song! Include details like who it’s for, the occasion, key emotions, inside jokes, or any must-have lyrics or themes. The more details, the more personal your song will be!"}
                      >
                        <IconHelp className={classes.spacing + " " + classes.spacingLeft}/>
                      </Tooltip>
                      <TextField
                      id="enter-song-info"
                      className={classes.spacing}
                      label="Song Details"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={4}
                      value = {inputs.ossSongInfo}
                      onChange = {(event) => changeVal(event, "ossSongInfo")}
                      onBlur = {() => blurField("ossSongInfo")}
                      error = {Boolean(errors.ossSongInfo)}
                      helperText={errors.ossSongInfo}
                      />
                      <Typography variant="body1">{inputs.ossSongInfo.length} / {inputLimits.ossSongInfo.max}</Typography>
                    </Box>
                    <Box className={classes.spacing}>
                      What style would you like your song to be?
                      <Tooltip
                      // followCursor
                      title={"Choose a genre or mood for your song—pop, country, rock, jazz, heartfelt, funny, or anything in between! If you’re unsure, describe the vibe you want, and we’ll match it to a style."}
                      >
                        <IconHelp className={classes.spacing + " " + classes.spacingLeft}/>
                      </Tooltip>
                      <TextField
                      id="enter-song-style"
                      className={classes.spacing}
                      label="Song Style"
                      variant="outlined"
                      fullWidth
                      value = {inputs.ossSongStyle}
                      onChange = {(event) => changeVal(event, "ossSongStyle")}
                      onBlur = {() => blurField("ossSongStyle")}
                      error = {Boolean(errors.ossSongStyle)}
                      helperText={errors.ossSongStyle}
                      />
                      <Typography variant="body1">{inputs.ossSongStyle.length} / {inputLimits.ossSongStyle.max}</Typography>
                    </Box>
                    <Box
                    className={classes.spacing}
                    >
                      Video Call Appointment
                      <FormControl fullWidth>
                        <InputLabel id="dates" className={classes.spacing}>Date</InputLabel>
                        <Select
                          labelId="datesLabel"
                          id="datesSelect"
                          className={classes.spacing}
                          value={date}
                          label="Date"
                          onChange={handleChangeDate}
                        >
                          {dates.map((step, index) => (
                            <MenuItem key={index} value={step}>{step}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {date ?
                        <FormControl fullWidth>
                          <InputLabel id="times" className={classes.spacing}>Time</InputLabel>
                          <Select
                            labelId="timesLabel"
                            id="timesSelect"
                            className={classes.spacing}
                            value={time}
                            label="Time"
                            onChange={handleChangeTime}
                          >
                            {times[date].map((step, index) => (
                              <MenuItem key={index} value={step.dateTime}>{step.timeString}</MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                      :
                        <></>
                      }
                      
                    </Box>
                  </>
                }
                <div className={classes.spacing}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={disableSubmit}
                  >
                    Submit
                  </Button>
                </div>
              </Typography>
              

            </form>
          }
          
        </ThemeProvider>
      </Box>
    )
  }
}

export default Purchase
